import React, { useRef ,useState, useLayoutEffect, useReducer } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, Redirect, useHistory } from 'react-router-dom';
import { elastic as Menu } from 'react-burger-menu';
import { Loader } from '../../dumb/utils/loader/Loader';
import { Home } from '../Home';
import { About } from '../About';
import { Services } from '../Services';
import { Contact } from '../Contact';
import './header.scss';
//services comp
// import { MarketConnect} from '../services/market-connect/MarketConnect';
// import { Web } from '../services/web/Web';
// import { Client } from '../services/client/Client';
import { SingleServiceContainer } from '../../smart/services/SingleServiceContainer';
import { MultipleServicesContainer } from '../../smart/services/MultipleServicesContainer';

export const Header = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    const [count, setCount] = useState(0);
    // const [language, setLanguage] = useState("");
    const [filename, setFilename] = useState("");
    const [redirect, setRedirect] = useState(true);
    const [isMenuOpen, setIsMenuOpened] = useState(false);
    const initialState = { lang: "IT-it" };

    function HandleClick(filename:string) {
        // console.log("handle " + filename)
        setCount(count + 1)
        setFilename(filename)
        setRedirect(false)
    }

    let handleStateChange = (state:any) => 
        setIsMenuOpened(state.isOpen)
    
    // This can be used to close the menu, e.g. when a user clicks a menu item
    let closeMenu = (state: any) =>
        setIsMenuOpened(false)

    function init(initialLang:any) {

        return initialLang;
    }

    function reducer(state:any, action:any) {

        switch (action.type) {
            case 'IT-it':
                return initialState;
            case 'EN-en':
                return { lang: "EN-en" };
            default:
                return state;
        }
    }

    let onChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) =>{

        var safeSearchTypeValue: string = e.currentTarget.value;

        setCount(count + 1)

        // setTimeout(() => $('#ponji').val(safeSearchTypeValue),0); 
        
        dispatch({ type: safeSearchTypeValue })
    }

    const [state, dispatch] = useReducer(reducer, initialState, init);

    useLayoutEffect(() =>

        setIsOnline(true), [setIsOnline, isOnline]
    );

    // useLayoutEffect(() =>

    //     setLanguage(props.language), [setLanguage, language]
    // );

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return <Router>
            {/* <Menu pageWrapId={"main-container"} outerContainerId={"root"}> */}
            <Menu onStateChange={(state) => handleStateChange(state)} isOpen={isMenuOpen} className="d-lg-none d-xl-block" right pageWrapId={"homeless-container"} outerContainerId={"main-container"}>
                <Link onClick={() => {

                    setCount(count + 1)
                    setIsMenuOpened(false)
                }
                 } to={'/Home'} > HOME </Link>
                <Link onClick={() => {

                    // setCount(count + 1)
                    // setFilename("about")
                    // setRedirect(false)
                    HandleClick("about")
                    setIsMenuOpened(false)
                    
                }
                } to={'/About'} > CHI SIAMO </Link>
                <Link onClick={() => {

                    // setCount(count + 1)
                    // setFilename("services")
                    // setRedirect(false)
                    HandleClick("services")
                    setIsMenuOpened(false)
                }
                } to={'/ServiceServices'} > SERVIZI </Link>
                <Link onClick={() => {

                    // setCount(count + 1)
                    // setFilename("contact")
                    // setRedirect(false)
                    HandleClick("contacts")
                    setIsMenuOpened(false)
                }
                } to={'/Contacts'} > CONTATTI </Link>
                <a rel="noopener noreferrer" href="/mcwp3" target="_blank">LOGIN</a>

            </Menu>
            <header id="page-wrap">
                
                <div className="header-area ">
                    <div className="default-select" style={{ float: "left", opacity:"0.7" }} id="">
                        
                        {/* {count}
                        {state.lang} */}
                        {/* <select id="ponji" className="selectpicker dropup" data-dropup-auto="false" data-width="fit" value={state.lang} onChange={e => onChangeSelect(e)}> 
                            <option value="IT-it">IT</option>
                            <option value="EN-en">EN</option>
                        </select> */}
                    </div>
                    <div className="header-top_area d-none d-lg-block">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-6 col-md-6 " data-subtext="Heinz">
                                    {/* <div className="social_media_links">
                                        <a href="/#">
                                            <i className="fa fa-linkedin"></i>
                                        </a>
                                        <a href="/#">
                                            <i className="fa fa-facebook"></i>
                                        </a>
                                        <a href="/#">
                                            <i className="fa fa-google-plus"></i>
                                        </a>
                                    </div> */}
                                    {/* <div className="infront-logo">
                                        <a rel="noopener noreferrer" href="https://www.infrontfinance.com/" target="_blank"></a>
                                    </div> */}
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <div className="short_contact_list">
                                        <ul>
                                            <li><a href={`mailto:customerservice@infrontfinance.com`}> <i className="fa fa-envelope"></i> customerservice@infrontfinance.com</a></li>
                                            <li><a href={`tel:+39 02 94755082`}> <i className="fa fa-phone"></i> +39 02 87330815</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="sticky-header" className="main-header-area">
                        <div className="container">
                            <div className="header_bottom_border">
                                <div className="row align-items-center">
                                    <div className="col-xl-3 col-lg-2">
                                        <div className="logo">
                                            <div className="infront-logo">
                                                <a rel="noopener noreferrer" href="https://www.infrontfinance.com/" target="_blank"></a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-7">
                                        <div className="main-menu  d-none d-lg-block">
                                            <nav className="">
                                                <ul id="navigation" className="">
                                                   
                                                    <li><Link onClick={() => setCount(count + 1)} to={'/Home'} className="nav-link"> HOME </Link></li>
                                                    <li><Link onClick={() => {

                                                            setCount(count + 1)
                                                            setFilename("about")
                                                            setRedirect(false)
                                                        }
                                                    } to={'/About'} className="nav-link"> CHI SIAMO </Link></li>
                                                    <li><Link onClick={() => {

                                                            setCount(count + 1)
                                                            setFilename("services")
                                                            setRedirect(false)
                                                        }
                                                    } to={'/ServiceServices'} className="nav-link"> SERVIZI </Link></li>
                                                    <li><Link onClick={() => {

                                                            setCount(count + 1)
                                                            setFilename("contacts")
                                                            setRedirect(false)
                                                        }
                                                    } to={'/Contacts'} className="nav-link"> CONTATTI </Link></li>
                                                </ul>
                                            </nav>
                                            {/* <nav>
                                                <ul id="navigation">
                                                    <li><a className="active" href="index.html">home</a></li>
                                                    <li><a href="about.html">About</a></li>
                                                    <li><a href="service.html">Services</a></li>
                                                    <li><a href="/#">blog <i className="ti-angle-down"></i></a>
                                                        <ul className="submenu">
                                                            <li><a href="blog.html">blog</a></li>
                                                            <li><a href="single-blog.html">single-blog</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="/#">pages <i className="ti-angle-down"></i></a>
                                                        <ul className="submenu">
                                                            <li><a href="elements.html">elements</a></li>
                                                            <li><a href="Portfolio.html">Portfolio</a></li>
                                                            <li><a href="portfolio_details.html">Portfolio details</a></li>
                                                        </ul>
                                                    </li>
                                                    <li><a href="contact.html">Contact</a></li>
                                                </ul>
                                            </nav> */}
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-3 d-none d-lg-block">
                                        <div className="Appointment">
                                            <div className="search_button">
                                                <a href="/#">
                                                    <i className="ti-search"></i>
                                                </a>
                                            </div>
                                            <div className="book_btn d-none d-lg-block">
                                                {/* old login pop up internal modal */}
                                                {/* <a className="popup-with-form" href="#test-form">LOGIN</a> */}
                                                {/* end */}
                                                <a rel="noopener noreferrer" href="/mcwp3" target="_blank">LOGIN</a>
                                            </div>
                                            {/* <p style={{ color: "white" }}>LANG: {state.lang}</p> */}
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="mobile_menu d-block d-lg-none"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <Switch>
                <Route
                    exact
                    path="/"
                    render={({ history }) => {
                        // history.push('/home')
                        return (
                            <Redirect to="/home" /> 
                        )
                    }}
                />
                <Route exact path='/Home' render={(props) => <Home key={count} {...props} count={count} language={state.lang} clickhandler={HandleClick}/>} />
                <Route exact path='/About' render={(props) => <About key={count} {...props} filename={filename} redirect={redirect} clickhandler={HandleClick} count={count} />} />
                {/* <Route exact path='/Services' render={(props) => <Services key={count} {...props} count={count} />} /> */}
                <Route exact path='/Contacts' render={(props) => <Contact key={count} {...props} filename={filename} redirect={redirect} clickhandler={HandleClick} count={count} />} />
                {/**service & and services list */}
                <Route exact path='/Service' render={(props) => <SingleServiceContainer key={count} {...props} count={count} language={state.lang} filename={filename} redirect={redirect} clickhandler={HandleClick} refresh={true}/>} />
                <Route exact path='/ServiceServices' render={(props) => <MultipleServicesContainer key={count} {...props} count={count} language={state.lang} filename={filename} redirect={redirect} clickhandler={HandleClick} refresh={true} />} />
                {/* <Route path='/contact' component={Header} />
                <Route path='/about' component={ServiceArea} /> */}
            </Switch>
        </Router>
}